/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var InteriorProtocolState;
(function (InteriorProtocolState) {
    InteriorProtocolState["Clean"] = "Clean";
    InteriorProtocolState["Dirty"] = "Dirty";
})(InteriorProtocolState || (InteriorProtocolState = {}));
export function InteriorProtocolStateFromJSON(json) {
    return InteriorProtocolStateFromJSONTyped(json, false);
}
export function InteriorProtocolStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InteriorProtocolStateToJSON(value) {
    return value;
}
